import { defineComponent } from 'vue';
import { tradeAreaClient } from '../lib/client';
import Spinner from './Spinner.vue';
import $ from 'jquery';
export default defineComponent({
    name: 'ProjectStep',
    components: { Spinner },
    props: {
        parent: {
            type: Object,
            required: true,
        },
        variation: {
            type: Object,
            required: true,
        },
        mods: {
            type: Array,
            required: true,
        },
        projectId: {
            type: Number,
            default: 0,
        },
        room: {
            type: String,
            default: '',
        },
    },
    emits: ['select'],
    data() {
        return {
            isAddNewRoomFieldActive: false,
            isCreateProjectFieldActive: false,
            loading: true,
            projects: [],
            selectedProject: null,
            selectedRoom: '',
            newProject: '',
            newRoom: '',
        };
    },
    computed: {
        canAddToProject() {
            return this.selectedProject !== null && this.selectedRoom !== '';
        },
    },
    watch: {
        selectedRoom() {
            this.emitSelect();
        },
    },
    async beforeMount() {
        this.loading = true;
        await this.fetchProjects();
        this.selectedProject = this.findProject(this.projectId);
        this.selectedRoom = this.room;
        this.isCreateProjectFieldActive = this.projects.length === 0;
        if (this.selectedProject !== null) {
            this.isAddNewRoomFieldActive = this.selectedProject.rooms.length === 0;
        }
        this.loading = false;
    },
    mounted() {
        let maxHeight = $('.modal__content').height();
        if (maxHeight === undefined)
            return;
        $('.project-step > div').css('max-height', maxHeight);
        $('.p-step-moodboard__carousel img').css('max-height', maxHeight);
        $('.p-step-moodboard__carousel').owlCarousel({
            items: 1,
            loop: false,
            //autoHeight: true,
            nav: false,
            dots: true,
        });
    },
    methods: {
        async fetchProjects() {
            this.projects = await tradeAreaClient.getProjects({ limit: 0 });
            console.log('Fetched projects', this.projects);
        },
        async createProject() {
            this.loading = true;
            await tradeAreaClient.postProject({ title: this.newProject });
            await this.fetchProjects();
            this.selectedProject = this.findProjectByTitle(this.newProject);
            this.newProject = '';
            this.isCreateProjectFieldActive = false;
            // new project should always have no rooms
            this.isAddNewRoomFieldActive = true;
            this.loading = false;
        },
        findProject(id) {
            return this.projects[this.projects.findIndex((p) => p.id === id)] || null;
        },
        findProjectByTitle(title) {
            return this.projects[this.projects.findIndex((p) => p.title === title)] || null;
        },
        addRoomToProject() {
            if (this.selectedProject === null)
                return;
            this.selectedProject.rooms.push({
                name: this.newRoom,
                products: [],
            });
            this.selectedRoom = this.newRoom;
            this.newRoom = '';
            this.isAddNewRoomFieldActive = false;
        },
        emitSelect() {
            if (this.selectedProject === null)
                return;
            this.$emit('select', this.selectedProject, this.selectedRoom);
        },
    },
});
